__turbopack_context__.v({
  "container": "checkboxField-module-scss-module__IVljWG__container",
  "label": "checkboxField-module-scss-module__IVljWG__label",
  "label-clickable-true": "checkboxField-module-scss-module__IVljWG__label-clickable-true",
  "label-disabled-true": "checkboxField-module-scss-module__IVljWG__label-disabled-true",
});
